import moment, { Moment } from 'moment';

export const DAY_IN_MS = 86400000;

export const roundToNextInterval = (date: Date, interval: number) => {
  if (interval <= 0) {
    throw new Error('interval must be greater than 0');
  }

  const momentDate = moment(date);
  const remainder = interval - (momentDate.minute() % interval);
  return momentDate.add(remainder, 'minutes').toDate();
};

export const getDaysInMonth = (date: Date) => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
};

export const getDaysInRange = (startDate: Date, lastDate: Date) => {
  const start = startDate.getTime();
  const last = lastDate.getTime();
  let current = Number(start);
  const result = [new Date(current)];
  while (current < last) {
    current += DAY_IN_MS;
    const nextDay = new Date(current);
    result.push(nextDay);
  }
  return result;
};

export const isTheSameDay = (firstDate: Date, secondDate: Moment): boolean => {
  return (
    firstDate.getFullYear() === parseInt(secondDate.format('YYYY'), 10) &&
    firstDate.getMonth() === parseInt(secondDate.format('M'), 10) - 1 &&
    firstDate.getDate() === parseInt(secondDate.format('D'), 10)
  );
};
